import { MsalAuthProvider, LoginType, IAzureADProps } from 'react-aad-msal';
import store from 'state/RootReducer';

/**
 * Configuration for the Azure AD authentication provider.
 */
const config: any = {
    auth: {
        authority: process.env.REACT_APP_AAD_AUTHORITY,
        clientId: process.env.REACT_APP_AAD_CLIENT_ID,
        redirectUri: `${window.location.origin}/${
            process.env.NODE_ENV === 'production'
                ? process.env.REACT_APP_AAD_REDIRECT_URI
                : 'callback'
        }`,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
};

/**
 * Authentication parameters for requesting specific scopes.
 */
const authenticationParameters = {
    scopes: ['user.read'],
};

/**
 * Options for configuring the authentication behavior.
 */
const options = {
    loginType: LoginType.Popup,
    tokenRefreshUri: `${window.location.origin}/auth.html`,
};

/**
 * Authentication provider instance for Azure AD authentication.
 */
export const AADProvider = new MsalAuthProvider(
    config,
    authenticationParameters,
    options
);

/**
 * Props for configuring Azure AD authentication.
 * @type {IAzureADProps}
 */
export const azureAdProps: IAzureADProps = {
    provider: AADProvider,
    forceLogin: false,
    reduxStore: store,
};
